import { sendRequest } from "@api/clients/axios";
import type { useQueryClient } from "@tanstack/react-query";
import type { Doc } from "@types_def/models/delivery.types";
import { toast } from "react-toastify";

import { invalidateDeliveryDetailCache } from "@/components/Delivery/cache";

type UpdateValidationDocsInput = {
  id: number;
  validationDocs: Doc[];
};

async function updateValidationDocs(
  input: UpdateValidationDocsInput,
  queryClient: ReturnType<typeof useQueryClient>
) {
  try {
    await sendRequest("post", "/delivery/update-validation-docs", input);
    toast("Documents modifiés avec succès", {
      position: "bottom-right",
      type: "success",
    });
    await invalidateDeliveryDetailCache(queryClient, input.id);
  } catch (_error) {
    toast("Une erreur est survenue", {
      position: "bottom-right",
      type: "error",
    });
  }
}

export { updateValidationDocs };
